export default {
    name: 'Footer',
    methods: {
        goHome() {
            this.$router.push({name: 'Home'})
        }
    }
}